import { useQuery } from "@tanstack/react-query"

import { useCasesQueryKeys } from "./use-cases-query-keys"
import { listAllUseCasesAdmin, listUseCases } from "../api/use-cases-api"

export function useUseCases() {
  return useQuery({
    queryKey: useCasesQueryKeys.list(),
    queryFn: listUseCases,
    staleTime: 30_000,
  })
}

export function useAllUseCasesAdmin(enabled: boolean) {
  return useQuery({
    queryKey: useCasesQueryKeys.adminList(),
    queryFn: listAllUseCasesAdmin,
    staleTime: 30_000,
    enabled,
  })
}
